import MUIDataTable from "mui-datatables";
import { Chip, IconButton, Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faEye } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import moment from "moment";

export default function SubscribersList({ subscriptions, onCancel }) {
    const history = useHistory();

    const columns = [
        {
            name: 'id',
            label: 'ID',
            options: { display: false }
        },
        {
            name: 'plan',
            label: 'Plan',
            options: {
                customBodyRender: (plan) => plan ? plan.name : 'N/A'
            }
        },
        {
            name: 'beneficiary',
            label: 'Beneficiario',
            options: {
                customBodyRender: (user) => user ? `${user.name} ${user.last_name}` : 'N/A'
            }
        },
        {
            name: 'payer',
            label: 'Pagador',
            options: {
                customBodyRender: (user) => user ? `${user.name} ${user.last_name}` : 'N/A'
            }
        },
        {
            name: 'status',
            label: 'Estado',
            options: {
                customBodyRender: (value) => {
                    let color = 'default';
                    let label = value;
                    
                    switch(value) {
                        case 'active': color = 'success'; label = 'Activo'; break;
                        case 'pending': color = 'warning'; label = 'Pendiente Pago'; break;
                        case 'past_due': color = 'error'; label = 'Moroso'; break;
                        case 'canceled': color = 'default'; label = 'Cancelado'; break;
                        case 'trialing': color = 'info'; label = 'En Prueba'; break;
                        default: break;
                    }

                    return <Chip label={label} color={color} size="small" />;
                }
            }
        },
        {
            name: 'next_renewal_date',
            label: 'Próximo Cobro',
            options: {
                customBodyRender: (value) => value ? moment(value).format('L') : '-'
            }
        },
        {
            name: 'actions',
            label: 'Acciones',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    const sub = subscriptions[dataIndex];
                    return (
                        <div>
                            <Tooltip title="Ver Detalle">
                                <IconButton 
                                    color="primary"
                                    onClick={() => history.push(`/subscriptions/detail/${sub.id}`)}
                                >
                                    <FontAwesomeIcon icon={faEye} />
                                </IconButton>
                            </Tooltip>
                            
                            {sub.status === 'active' && (
                                <Tooltip title="Cancelar Suscripción">
                                    <IconButton 
                                        color="error"
                                        onClick={() => onCancel(sub.id)}
                                    >
                                        <FontAwesomeIcon icon={faBan} />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </div>
                    );
                },
                filter: false,
                sort: false,
            }
        }
    ];

    return (
        <MUIDataTable
            title={"Listado Global de Suscriptores"}
            data={subscriptions}
            columns={columns}
            options={{
                selectableRows: 'none',
                elevation: 1,
                print: false,
                viewColumns: false
            }}
        />
    );
}